import React, {useEffect, useState} from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Badge } from 'primereact/badge';
import './DocumentsDashboard.scss'
import {Fieldset} from "primereact/fieldset";
import {InputNumber} from "primereact/inputnumber";
import {getMaintenanceKardex, getMaintenanceKardexByType, getUnitMaintenanceData} from "../../Integration";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Dialog} from "primereact/dialog";
import ServiceFormDialog from "./ServiceFormDialog";
const Maintenance = ({ formData, handleInputChange, id, tienePermiso }) => {
    const [globalFilter, setGlobalFilter] = useState('');
    const [dialogVisible, setDialogVisible] = useState(false);
    const [maintenanceData, setMaintenanceData] = useState([]);
    const [maintenance, setMaintenance] = useState([]);
    const [selectedMaintenance, setSelectedMaintenance] = useState(null);
    const [generalData, setGeneralData] = useState([]);


    useEffect(() => {
        getMaintenanceKardex(id).then((data) => {
            setMaintenanceData(data);
        });
        getUnitMaintenanceData(id).then((data) => {
            setGeneralData(data);
        });
    }, []);

    useEffect(() => {
        if(selectedMaintenance) {
            getMaintenanceKardexByType(id, selectedMaintenance.ID).then((data) => {
                setMaintenance(data);
            })
        }
    }, [selectedMaintenance]);

    const statusBodyTemplate = (rowData) => {
        const getSeverity = (status) => {
            switch (status) {
                case 'activo': return 'success';
                case 'proximo': return 'warning';
                case 'vencido': return 'danger';
                default: return 'info';
            }
        };

        return <Tag value={rowData?.estatus?.toUpperCase()} severity={getSeverity(rowData.estatus)} />;
    };

    const showMaintenance = async (maintenance) => {
        setSelectedMaintenance(maintenance);
        setDialogVisible(true);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="action-buttons">
                <Button icon="pi pi-eye" className="p-button-rounded p-button-text p-button-sm" tooltip="Ver"
                        onClick={() => showMaintenance(rowData)}/>
            </div>
        );
    };

    const formatCurrency = (value) => {
        if (!value) return '$0.00';
        return `$${parseFloat(value).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`;
    };

    const frequency = (rowData) => {
        const value = rowData.FRECUENCIA;
        if (value == null) return '';
        const suffix = value.toString().length <= 2 ? ' meses' : ' km';
        return `${value} ${suffix}`;
    };

    const costoBodyTemplate = (rowData) => {
        return formatCurrency(rowData.COSTO);
    };

    const lastYearTotal = () => {
        let total = 0;

        for (let main of maintenance) {
            total += main.COSTO;
        }

        return formatCurrency(total);
    };

    const footerGroup = (
        <ColumnGroup>
            <Row>
                <Column footer="Total:" colSpan={4} footerStyle={{ textAlign: 'right' }} />
                <Column footer={lastYearTotal} />
            </Row>
        </ColumnGroup>
    );

    const dialogFooterTemplate = () => {
        return <Button label="Cerrar"  onClick={() => {
            setDialogVisible(false);
            setSelectedMaintenance(null)
        }} />;
    };


    const header = (
        <div className="table-header">
            <h5 className="header-title">Kardex de Mantenimiento</h5>
            <span className="p-input-icon-left search-input">
        <i className="pi pi-search" />
        <InputText
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar mantenimientos..."
        />
      </span>
        </div>
    );

    const legendTemplate = (
        <div className="flex align-items-center justify-content-between w-full">
            <div>
                <h3 className="m-0 text-lg font-semibold text-color">Datos De Mantenimiento</h3>
                <p className="m-0 mt-1 text-sm text-color-secondary">Sistema de Gestión Vehicular</p>
            </div>
        </div>
    );

    return (
        <Fieldset legend={legendTemplate} toggleable>
            <div className="maintenance-dashboard">
                {/* Header con información del vehículo */}
                <Card className="vehicle-info-card">
                    <div className="vehicle-header">
                        <h3>Datos de Mantenimiento</h3>
                        {/*<div className="last-update">
                            <span>Última Revisión: 24/01/2024</span>
                        </div>*/}
                    </div>

                    <div className="info-grid">
                        <div className="info-section" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <div className="info-group">
                                <div className="info-item">
                                    <label>Kilometraje Actual</label>
                                    <span className="value-large">{Number(formData.KILOMETRAJE || 0).toLocaleString('es-MX')}</span>
                                </div>
                                {/*<div className="info-item">
                                    <label>Rendimiento Últ. 30 días</label>
                                    <span className="value-large">{formData.RENDIMIENTO}</span>
                                </div>*/}

                            </div>

                            {/*<div className="info-group">
                                <div className="info-item">
                                    <label>Estatus</label>
                                    <Badge value={vehicleData.estatus} severity="success" className="status-badge"/>
                                </div>
                                <div className="info-item">
                                    <label>Prom. KM Diario (60 días)</label>
                                    <span className="value">{vehicleData.promedioKmDiario}</span>
                                </div>
                            </div>*/}

                        </div>

                        <div className="info-section">
                            {/*<div className="info-item full-width">
                                <label>Índice Mantenimientos (MTotal/Km) 6 Meses</label>
                                <span className="value">{vehicleData.indiceMantenimiento}</span>
                            </div>*/}

                            <div className="info-group">
                                <div className="fieldGroup">
                                    <label className="label">Litros Aceite</label>
                                    <InputNumber
                                        value={formData.LITROS_ACEITE}
                                        onChange={(e) => handleInputChange('LITROS_ACEITE', e.value)}
                                        disabled={!tienePermiso}
                                    />
                                </div>

                                <div className="fieldGroup">
                                    <label className="label">Tipo Aceite</label>
                                    <InputText
                                        value={formData.TIPO_ACEITE}
                                        onChange={(e) => handleInputChange('TIPO_ACEITE', e.target.value)}
                                        disabled={!tienePermiso}
                                    />
                                </div>
                            </div>
                            <div className="info-group">
                                <div className="fieldGroup">
                                    <label className="label">Litros Combustible</label>
                                    <InputNumber
                                        value={formData.LITROS_COMBUSTIBLE}
                                        onChange={(e) => handleInputChange('LITROS_COMBUSTIBLE', e.value)}
                                        disabled={!tienePermiso}
                                    />
                                </div>

                                <div className="fieldGroup">
                                    <label className="label">Tipo Llanta</label>
                                    <InputText
                                        value={formData.TIPO_LLANTA}
                                        onChange={(e) => handleInputChange('TIPO_LLANTA', e.target.value)}
                                        disabled={!tienePermiso}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="info-section totals">
                            <div className="total-item">
                                <label>Total Mantenimientos</label>
                                <span
                                    className="value-currency">{formatCurrency(generalData.TOTAL)}</span>
                            </div>
                            <div className="total-item">
                                <label>Piezas</label>
                                <span className="value-currency">{formatCurrency(generalData.PIEZAS)}</span>
                            </div>
                            <div className="total-item">
                                <label>Mano Obra</label>
                                <span className="value-currency">{formatCurrency(generalData.MANO_OBRA)}</span>
                            </div>
                        </div>
                    </div>

                    {/*<div className="info-grid">
                        <div className="info-section">
                            <div className="info-group">
                                <div className="fieldGroup">
                                    <label className="label">Litros Aceite</label>
                                    <InputNumber
                                        value={formData.LITROS_ACEITE}
                                        onChange={(e) => handleInputChange('LITROS_ACEITE', e.value)}
                                        className="p-inputtext-sm"
                                    />
                                </div>

                                <div className="fieldGroup">
                                    <label className="label">Tipo Aceite</label>
                                    <InputText
                                        value={formData.TIPO_ACEITE}
                                        onChange={(e) => handleInputChange('TIPO_ACEITE', e.target.value)}
                                        className="p-inputtext-sm"
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="info-section">
                            <div className="info-group">
                                <div className="fieldGroup">
                                    <label className="label">Litros Combustible</label>
                                    <InputNumber
                                        value={formData.LITROS_COMBUSTIBLE}
                                        onChange={(e) => handleInputChange('LITROS_COMBUSTIBLE', e.value)}
                                        className="p-inputtext-sm"
                                    />
                                </div>

                                <div className="fieldGroup">
                                    <label className="label">Tipo Llanta</label>
                                    <InputText
                                        value={formData.TIPO_LLANTA}
                                        onChange={(e) => handleInputChange('TIPO_LLANTA', e.target.value)}
                                        className="p-inputtext-sm"
                                    />
                                </div>
                            </div>
                        </div>

                    </div>*/}
                </Card>

                {/* Tabla de mantenimientos */}
                <Card className="maintenance-table-card">
                    <DataTable
                        value={maintenanceData}
                        header={header}
                        // globalFilter={globalFilter}
                        className="maintenance-table"
                        emptyMessage="No se encontraron mantenimientos."
                        stripedRows
                        responsiveLayout="scroll"
                    >
                        <Column field="SERVICIO" header="Tipo" sortable className="tipo-column"/>
                        <Column field="FRECUENCIA" header="Frec." body={frequency} sortable className="frecuencia-column"/>
                        <Column field="FECHA" header="Fecha" sortable/>
                        <Column field="KILOMETRAJE" header="Kilometraje" sortable/>
                        <Column field="NUM_VECES" header="Veces" sortable style={{maxWidth: '120px'}}/>
                        {/*<Column field="promedio" header="Prom." sortable/>*/}
                        <Column field="COSTO" header="Costo" body={costoBodyTemplate} sortable/>
                        <Column field="PROXIMO" header="Próx." sortable/>
                        <Column field="KMRESTANTES" header="KM Falt." sortable/>
                        <Column field="DIAS_RESTANTES" header="Días" sortable/>
                        {/*<Column field="estatus" header="Estatus" body={statusBodyTemplate} sortable/>*/}
                        <Column header="Acciones" body={actionBodyTemplate} className="actions-column"/>
                    </DataTable>
                </Card>
                <Dialog header={selectedMaintenance?.SERVICIO} visible={dialogVisible} style={{ width: '75vw' }} maximizable
                        modal contentStyle={{ minHeight: '200px' }} onHide={() => setDialogVisible(false)} footer={dialogFooterTemplate}>
                    {maintenance && maintenance.length > 0 && (
                        <DataTable value={maintenance} size="small" showGridlines footerColumnGroup={footerGroup} scrollable scrollHeight="flex" tableStyle={{ minWidth: '50rem' }}>
                            <Column field="ID" header="ID" style={{minWidth: '5rem'}}></Column>
                            <Column field="FECHA" header="Fecha" style={{minWidth: '6rem'}}></Column>
                            <Column field="CATEGORIA" header="Categoria" style={{minWidth: '8rem'}}></Column>
                            <Column field="CHOFER" header="Operador" style={{minWidth: '10rem'}}></Column>
                            <Column field="COSTO" header="Costo" body={costoBodyTemplate}></Column>
                            <Column field="KILOMETRAJE" header="Kilometraje"></Column>
                            <Column field="PROXIMO" header="Proximo"></Column>
                            <Column field="NOTA" header="Nota"></Column>
                            <Column field="REFERENCIA" header="Referencia"></Column>
                            <Column field="TIPO" header="Tipo"></Column>
                        </DataTable>
                    )}
                </Dialog>
            </div>
        </Fieldset>

    );
};

export default Maintenance;